import { createApp } from 'vue'
import App from './App.vue'
import { VueCookieNext } from 'vue-cookie-next'
import { defineRule } from "vee-validate";

const environment = process.env.NODE_ENV || "development";
export const IS_PRODUCTION = environment === "production";
const isDeploy = environment === "production" || environment === "staging";
export const IS_MEMBER_REGISTRATION_DEV = isDeploy ? !IS_PRODUCTION : process.env.VUE_APP_MEMBER_REGISTRATION_ENV !== 'prod';
export const IS_STRIPE_DEV = isDeploy ? !IS_PRODUCTION : process.env.VUE_APP_STRIPE_ENV !== 'prod';
export const IS_UI_ONLY_MODE = isDeploy ? false : process.env.VUE_APP_UI_ONLY_MODE === 'yes';

export const MEMBER_REGISTRATION_ACTION_NAMES = [
  "signup",
  "memberRegistration",
  "newUser"
];
export const TRIAL_LIGHT_ACTION_NAMES = [
  "signup-light"
];
export const TRIAL_EL_ACTION_NAMES = [
  "signup-el"
];
export const TRIAL_CAMPAIGN_ACTION_NAMES = [
  "signup-cmp"
];
export const CAMPAIGN_SUCCESS_ACTION_NAMES = [
  "success-cmp"
];

export const LIGHT_TRIAL_TYPE_KEY = 'light'
export const ELEARNING_TRIAL_TYPE_KEY = 'elearning'
export const CAMPAIGN_TRIAL_TYPE_KEY = 'campaign'

export const MEMBER_REGISTRATION_URL = IS_MEMBER_REGISTRATION_DEV ? "/memberRegistrationDev" : "/memberRegistration";
export const AUTHENTICATE_URL = "/authenticate";
export const MEMBER_MEMBER_INFO_URL = "/memberMemberInfo";
export const MEMBER_PAYMENT_HELPERS_URL = "/memberPaymentHelpers";

defineRule("required", (value) => {
  if (!value) {
    return "This is required";
  }

  return true;
});

defineRule("min", (value, [min]) => {
  if (value && value.length < min) {
    return `Should be at least ${min} characters`;
  }

  return true;
});

defineRule("confirmed", (value, [other]) => {
  if (value !== other) {
    return `Passwords do not match`;
  }

  return true;
});

defineRule("email", (value) => {
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return `Should be a valid email address`;
  }

  return true;
});

defineRule("phoneNumber", (value) => {
  if (!/^[0-9]{9,12}$/i.test(value)) {
    return `Should be a valid phone number`;
  }

  return true;
});

const app = createApp(App)

app.use(VueCookieNext)

app.mount('#app')
